document.addEventListener('DOMContentLoaded', () => {
  const hamburgers = document.querySelectorAll('.hamburger[data-bs-toggle][data-bs-target]')
  hamburgers.forEach((hamburgerEl) => {
    const toggleType = hamburgerEl.getAttribute('data-bs-toggle')
    const targetEl = document.querySelector(hamburgerEl.getAttribute('data-bs-target'))
    if (targetEl) {
      switch (toggleType) {
        case 'offcanvas':
          hamburgerEl.addEventListener('click', (e) => {
            // workaround: for some reason, there is a bug with offcanvas on hamburger button
            // button is clicked twice, so the offcanvas never shows up
            // prevent second click
            e.preventDefault()
            e.stopPropagation()
          })
          break
        default:
          break
      }

      targetEl.addEventListener(`show.bs.${toggleType}`, () => {
        hamburgerEl.classList.add('is-active')
        targetEl.parentElement.classList.add('show')
      })

      targetEl.addEventListener(`hide.bs.${toggleType}`, () => {
        hamburgerEl.classList.remove('is-active')
        targetEl.parentElement.classList.remove('show')
      })
    }
  })
})
